import * as React from "react";
import styled from "styled-components";
import * as _ from "lodash";
import StyledModal from "styled-react-modal";

import { theme } from "src/library/utils";

import { Icon } from "../Icon";
import { Icons } from "../Icon/types";

export interface IframeModalProps {
  show: boolean;
  onDismiss: () => void;
  url?: string | null;
}

/**
 * iFrame modal component
 */
export const IframeModal: React.ReactFCWithChildren<IframeModalProps> = ({
  show,
  onDismiss,
  url
}) => {
  return (
    <ModalWrapper
      isOpen={show}
      onBackgroundClick={() => onDismiss()}
    >
      <ModalInner>
        <Icon
          className="close-icon"
          icon={Icons.CLOSE}
          onClick={() => onDismiss()}
        />

        <iframe src={url || undefined} />
      </ModalInner>
    </ModalWrapper>
  );
};

const ModalWrapper = StyledModal.styled`
  transition: ${theme.transition.quick};
  opacity: 1;
  position: relative;
  background: ${theme.colors.white};
  width: 80vw;
  height: 80vh;
  max-width: 25rem;
  max-height: 40rem;
  border-radius: 1rem;
  overflow: hidden;

  @media (min-width: 480px) {
    max-width: 39rem;
  }

  @media (min-width: 568px) {
    max-width: 50rem;
    max-height: 60rem;
  }

  @media (min-width: 768px) {
    max-width: 60rem;
    max-height: 40rem;
  }
`;

ModalWrapper.displayName = "ModalWrapper";

const ModalInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .close-icon {
    position: absolute;
    z-index: 2;
    top: 1rem;
    right: 2.4rem;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
